import { Errors as _Errors } from '@wener/utils';

/**
 * @deprecated use Errors from @wener/utils
 */
export const Errors = _Errors;
